/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { GroupBase, Props } from 'react-select';
import Select from 'react-select';
import { FormGroup, Label } from 'reactstrap';
import { UserMin } from '../../../constants/users';

type UserSelectOption = { value: string; label: string };

interface UserSelectFieldProps {
  label?: string;
  onChange: (userIds: string[]) => void;
  userIds?: string[];
  users: UserMin[];
  selectProps?: Props<UserSelectOption, true, GroupBase<UserSelectOption>>;
}

const getUserName = (user: UserMin) => `${user.firstName} ${user.surname}`;

export const UserSelectField = (props: UserSelectFieldProps) => {
  const { label = 'To', userIds, onChange, users, selectProps = {} } = props;

  const usersList: UserSelectOption[] = users.map((user) => ({ value: user._id, label: getUserName(user) }));
  const selectedUsers = usersList.filter((u) => userIds?.includes(u.value));

  return (
    <FormGroup>
      <Label for='users'>{label}</Label>
      <Select
        className='dont_translate'
        placeholder={'Users'}
        isClearable={false}
        options={usersList}
        isMulti={true}
        noOptionsMessage={() => 'No users available for selection'}
        value={selectedUsers ?? null}
        onChange={(selection) => onChange(selection.map((item: UserSelectOption) => item.value))}
        {...selectProps}
      />
    </FormGroup>
  );
};
